




















































































import { defineComponent, computed, useRoute } from '@nuxtjs/composition-api'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import {
  UserAgentState,
  USER_AGENT_NS
} from '~/store/modules/shared/userAgent/state'

export default defineComponent({
  components: {
    WantedBadge: () =>
      import('~/components/car/classifieds/badges/WantedBadge.vue'),
    ForRentBadge: () =>
      import('~/components/car/classifieds/badges/ForRentBadge.vue'),
    DamagedBadge: () =>
      import('~/components/car/classifieds/badges/DamagedBadge.vue'),
    NewBadge: () => import('~/components/car/classifieds/badges/NewBadge.vue'),
    DealersOnlyBadge: () =>
      import('~/components/car/classifieds/badges/DealersOnlyBadge.vue'),
    PromotedBadge: () =>
      import('~/components/car/classifieds/badges/PromotedBadge.vue'),
    OnlyLeasingBadge: () =>
      import('~/components/car/classifieds/badges/OnlyLeasingBadge.vue'),
    ForeignNumberBadge: () =>
      import('~/components/car/classifieds/badges/ForeignNumberBadge.vue'),
    WithoutVatBadge: () =>
      import('~/components/car/classifieds/badges/WithoutVatBadge.vue'),
    HomeDeliveryBadge: () =>
      import('~/components/car/classifieds/badges/HomeDeliveryBadge.vue'),
    InstallmentsBadge: () =>
      import('~/components/car/classifieds/badges/InstallmentsBadge.vue'),
    LeasingBadge: () =>
      import('~/components/car/classifieds/badges/LeasingBadge.vue'),
    OneClickAutoTouchBadge: () =>
      import('~/components/car/classifieds/badges/OneClickAutoTouchBadge.vue'),
    PaidClassifiedBadge: () =>
      import('~/components/car/classifieds/badges/PaidClassifiedBadge.vue'),
    AuditedBadge: () =>
      import('~/components/car/classifieds/badges/AuditedBadge.vue')
  },
  props: {
    scrollable: { type: Boolean, default: false }
  },
  setup() {
    const { state, getters } = useNamespacedStore<ClassifiedViewState>(
      CLASSIFIED_VIEW_NS
    )

    const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
      USER_AGENT_NS
    )
    const isMobile = computed(() => userAgentGetters('isMobile'))

    const route = useRoute()
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const userIsAdminOrOwner = computed(() => getters('userIsAdminOrOwner'))
    const isPromoted = computed(() => getters('isPromoted'))
    const isDealersOnly = computed(() => getters('isDealersOnly'))
    const isWanted = computed(() => getters('isWanted'))
    const isForRent = computed(() => getters('isForRent'))
    const isDamaged = computed(() => getters('isDamaged'))
    const isNew = computed(() => getters('isNew'))
    const isOnlyLeasing = computed(() => getters('isOnlyLeasing'))
    const extras = computed(() => state.classified?.extras)
    const hasLeasing = computed(() => getters('hasLeasing'))
    const foreignNumbers = computed(() =>
      extras.value?.some(ex => ex.name === 'taxfree_foreign_numbers')
    )
    const withoutVat = computed(() =>
      extras.value?.some(ex => ex.name === 'price_without_vat')
    )
    const paidClassified = computed(() => getters('paidClassified'))
    const hasOneClickAutoTouch = computed(() => getters('hasOneClickAutoTouch'))
    const userIsAdmin = computed(() => userGetters('isAdmin'))
    const isHomeDelivery = computed(() => {
      if (state.classified?.specifications?.length) {
        return state.classified?.specifications.some(
          sp => sp.name === 'home_delivery'
        )
      }
      return false
    })
    const hasExternalCertificate = computed(
      () => state.classified?.external_certificates
    )
    const showPromoBadge = computed(() => {
      if (isPromoted.value) {
        return route.value.query['from-promotion'] || userIsAdminOrOwner.value
      }
      return false
    })
    const monthlyInstallmentAmount = computed(() =>
      getters('getMonthlyInstallmentAmount')
    )
    const hasInstallments = computed(
      () => state.classified.finance && monthlyInstallmentAmount.value
    )
    const isInterestZero = computed(() => {
      return state.classified?.finance?.options?.interestPercentage === 0
    })

    const hasLeasingOrInstallments = computed(
      () => hasInstallments.value || hasLeasing.value
    )
    const numberOfBadgesWithoutFinance = computed(() => {
      return [
        showPromoBadge.value,
        withoutVat.value,
        isDamaged.value,
        isWanted.value,
        isDealersOnly.value,
        isForRent.value,
        isNew.value,
        isOnlyLeasing.value,
        userIsAdmin.value && paidClassified.value,
        foreignNumbers.value,
        isHomeDelivery.value,
        hasOneClickAutoTouch.value
      ].filter(b => !!b)?.length
    })

    const hasAnyBadge = computed(
      () =>
        showPromoBadge.value ||
        withoutVat.value ||
        isDamaged.value ||
        isWanted.value ||
        isDealersOnly.value ||
        isForRent.value ||
        isNew.value ||
        (hasInstallments.value && isMobile) ||
        isOnlyLeasing.value ||
        (userIsAdmin.value && paidClassified.value) ||
        foreignNumbers.value ||
        isHomeDelivery.value ||
        (hasLeasing.value && isMobile) ||
        hasExternalCertificate
    )

    return {
      showPromoBadge,
      isDealersOnly,
      isWanted,
      isForRent,
      isDamaged,
      isNew,
      isOnlyLeasing,
      extras,
      paidClassified,
      userIsAdmin,
      hasLeasing,
      isHomeDelivery,
      foreignNumbers,
      withoutVat,
      isInterestZero,
      hasInstallments,
      hasAnyBadge,
      hasLeasingOrInstallments,
      isMobile,
      numberOfBadgesWithoutFinance,
      hasOneClickAutoTouch,
      hasExternalCertificate
    }
  }
})
